import React, { useEffect, useState } from "react";
import Stepper from "../../ui/Stepper";
import { STEPPER_LIST_COUNTRY } from "../../../../constants/cms";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  clearCountryMedia,
  getCountryMedia,
  putCountryMedia,
} from "../../../../../store/slices/country";
import GalleryForm from "./galleryForm";
const Gallery = (props) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [saveAndNext, setSaveAndNext] = useState(false);
  const user = useSelector((state) => state?.userData?.user?.data);
  const userPermission = useSelector(
    (state) => state.userData?.userPermission?.data
  );
  const [initialValues, setInitialValues] = useState({});
  const dispatch = useDispatch();
  const { countryMediaData, putCountryMediaData } = useSelector(
    (state) => state.cmsCountry
  );
  useEffect(() => {
    if (id) {
      dispatch(getCountryMedia({ country_id: id }));
    }
    return () => {
      dispatch(clearCountryMedia());
    };
  }, [id]);
  useEffect(() => {
    if (putCountryMediaData) {
      if (saveAndNext) {
        navigate(`/cms/country/${putCountryMediaData?.country_id}/faqs`);
      }else{
        dispatch(getCountryMedia({ country_id: id }));
      }
      setSaveAndNext(false);
    }
  }, [putCountryMediaData]);
  useEffect(() => {
    if (countryMediaData) {
      let newvalues = {
        country_videos:
          countryMediaData.country_videos?.length > 0
            ? countryMediaData.country_videos
            : [
                {
                  video_url: "",
                  caption: "",
                },
              ],
        logo: countryMediaData?.country_data?.logo
          ? countryMediaData?.country_data?.logo
          : null,
        banner_images:
          countryMediaData?.banner_images?.length > 0
            ? countryMediaData?.banner_images
            : [{ image: "" }],
        country_images:
          countryMediaData?.country_images?.length > 0
            ? countryMediaData?.country_images
            : [{ image: "" }],
        last_updated: countryMediaData?.last_updated
          ? countryMediaData?.last_updated
          : null,
        updated_by: countryMediaData?.updated_by
          ? countryMediaData?.updated_by
          : null,
      };

      setInitialValues(newvalues);
    }
  }, [countryMediaData]);

  const submit = (values) => {
    let data = new FormData();
    if (values.logo != null && typeof values.logo != "string") {
      data.append("logo", values.logo);
    }
    if (values.logo === null) {
      data.append("logo", "");
    }
    for (const [index, entry] of values.banner_images.entries()) {
      if (entry?.image) {
        data.append(
          `banner_images_${entry?.id ? entry.id : `new${index}`}`,
          entry?.image
        );
      }
    }
    for (const [index, entry] of values.country_images.entries()) {
      if (entry?.image) {
        data.append(
          `country_images_${entry?.id ? entry.id : `new${index}`}`,
          entry?.image
        );
      }
    }
    data.append("country_videos", JSON.stringify(values.country_videos));
    data.append("user_id", user?.id);
    dispatch(putCountryMedia({ country_id: id }, data));
  };
  return (
    <div>
      <div className={"mt50"}>
        <div className={`${"stepper"} ${"examviewlist"}`}>
          <Stepper data={STEPPER_LIST_COUNTRY} activeStep={3} />
        </div>
      </div>
      <div>
        {id && (
          <GalleryForm
            submit={(e) => submit(e)}
            initialValues={initialValues}
            setSaveAndNext={setSaveAndNext}
            userPermission={userPermission}
          />
        )}
      </div>
    </div>
  );
};

export default Gallery;
